import { gql } from '@apollo/client'

export const PLAYLIST_GROUPS_QUERY = gql`
    query playlistGroup(
        $business_units:[String], 
        $departments:[String]){
        
      playlistGroupList(
        business_units:$business_units,
        departments:$departments) {
            name
            weight
            uuid
            playlists{
                name
                id
                itemsCount
                isLikedByCurrentUser
                uuid
                weight
            }
        }
    }
`;


